export default __webpack_public_path__ + "paddle_finance443c28.svg";